export const DISCOUNT_MILESTONE_OFFSETS = {
  desktop: {
    x: 48,
    y: 8,
  },
  mobile: {
    x: 48,
    y: 8,
  },
};
